<template>
  <div class="main contact" v-loading="contactLoading">
    <div class="contact-part1">
      <p class="title1">{{ $t('c-title1') }}</p>
      <p class="title2">{{ $t('c-title2') }}</p>
      <div class="contact-detail">
        <div class="contact-detail-dialog">
          <div class="contact-detail-part1 detail-part">
            <div>
              <div class="detail-title">{{ $t('firstname') }}</div>
              <div class="detail-content"><input type="text" v-model="first_name" maxlength="30"></div>
            </div>
            <div>
              <div class="detail-title">{{ $t('lastname') }}</div>
              <div class="detail-content"><input type="text" v-model="last_name" maxlength="30"></div>
            </div>
          </div>
          <div class="contact-detail-part2 detail-part">
            <div>
              <div class="detail-title">{{ $t('workemail') }}</div>
              <div class="detail-content"><input type="text" v-model="work_email" id="work_email"></div>
            </div>
            <div>
              <div class="detail-title">{{ $t('phone') }}</div>
              <div class="detail-content"><input type="text" v-model="phone_num" id="phone_num"></div>
            </div>
          </div>
          <div class="contact-detail-part3 detail-part">
            <div>
              <div class="detail-title">{{ $t('company') }}</div>
              <div class="detail-content"><input type="text" v-model="company_name"></div>
            </div>
            <div>
              <div class="detail-title">{{ $t('size') }}</div>
              <div class="detail-content"><input type="text" v-model="company_size"></div>
            </div>
          </div>
          <div class="contact-detail-part4 detail-part">
            <div>
              <div class="detail-title">{{ $t('location') }}</div>
              <div class="detail-content"><input type="text" v-model="location"></div>
            </div>
            <div>
              <div class="detail-title">{{ $t('industry') }}</div>
              <div class="detail-content"><input type="text" v-model="industry"></div>
            </div>
          </div>
          <div class="contact-send" @click="send">{{ $t('send') }}</div>
        </div>
      </div>
    </div>
    <div class="contact-part2">
      <div class="info-detail">
        <!-- <p>{{ $t('address') }}</p>
        <p>{{ $t('zipcode') }}</p>
        <p>{{ $t('tel') }}</p> -->
        <p>{{ $t('emaillabel') }} <a id="email" href="mailto:info@craitapp.com">{{ $t('email') }}</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'Crait | ' + this.$i18n.t('contact'), // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: this.$i18n.t('key-content')
      },
      {
        name: 'description',
        content: this.$i18n.t('description-content')
      }]
    }
  },
  data () {
    return {
      first_name: '',
      last_name: '',
      work_email: '',
      phone_num: '',
      company_name: '',
      company_size: '',
      location: '',
      industry: '',
      message: '',
      input_item: '',
      contactLoading: false
    }
  },
  created () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  methods: {
    checkEmpty () {
      let self = this
      let ele = document.getElementsByClassName('detail-content')
      let pre = ''
      for (let i = 0; i < ele.length; i++) {
        if (!ele[i].getElementsByTagName('input')[0].value) {
          pre = ele[i].previousElementSibling
          if (pre.innerHTML === 'Location' || pre.innerHTML === 'Industry') {
//            self.input_item = pre.innerHTML
          } else {
            self.input_item = pre.innerHTML.substr(0, pre.innerHTML.indexOf('*') - 1)
            self.$message({
              message: 'Please enter the ' + self.input_item,
              type: 'warning',
              duration: 2000
            })
            return false
          }
        }
      }
      if (!self.checkEmail(self.work_email)) {
        self.$message({
          message: 'Please enter a valid email',
          type: 'warning',
          duration: 2000
        })
        return false
      }
      if (!self.checkPhoneNum(self.phone_num)) {
        self.$message({
          message: 'Please enter a valid phone number',
          type: 'warning',
          duration: 2000
        })
        return false
      }
      self.sendApi()
    },
    checkEmail (email) {
      let emailReg = /^[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+((-[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)|(\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+))*@[\u4e00-\u9fa5_a-zA-Z0-9]+((\.|-)[\u4e00-\u9fa5_a-zA-Z0-9]+)*.[a-zA-Z0-9]+$/
      if (!emailReg.test(email)) {
        return false
      } else {
        return true
      }
    },
    checkPhoneNum (phone) {
      let phoneReg = /^([\d]{5,20})$/
      if (!phoneReg.test(phone)) {
        return false
      } else {
        return true
      }
    },
    sendApi () {
      let self = this
      self.contactLoading = true
      let params = {
        first_name: self.first_name,
        last_name: self.last_name,
        work_email: self.work_email,
        phone_num: self.phone_num,
        company_name: self.company_name,
        company_size: self.company_size,
        location: self.location,
        industry: self.industry
      }
      self.$axios.post('/proxy-api/client/suggest/index/contact-us', self.qs.stringify(params)).then(res => {
        self.contactLoading = false
        if (res.data.status === '0') {
          self.$message({
            message: 'Send success',
            type: 'success',
            duration: 2000
          })
          self.first_name = ''
          self.last_name = ''
          self.work_email = ''
          self.phone_num = ''
          self.company_name = ''
          self.company_size = ''
          self.location = ''
          self.industry = ''
        } else {
          self.$message({
            message: res.data.msg,
            type: 'warning',
            duration: 2000
          })
          console.log(res.data.msg)
        }
      }).catch(err => {
        self.contactLoading = false
        self.$message.error('Network error!')
        console.log(err)
      })
    },
    send () {
      this.checkEmpty()
    }
  }
}
</script>
<style lang="scss">
  .contact {
    position: relative;
    margin-top: 1.2rem !important;
    .contact-part1 {
      text-align: center;
      @media screen and (max-width: 760px) {
        text-align: left;
        padding: 0 .2rem;
      }
      .title1 {
        font-size: 0.3rem;
        color: #323232;
        font-weight: bold;
        @media screen and (max-width: 760px) {
          font-size: .23rem;
        }
      }
      .title2 {
        font-size: 0.24rem;
        color: #666;
        @media screen and (max-width: 760px) {
          margin-top: .2rem;
          font-size: .18rem;
        }
      }
      img {
        max-width: 100%;
        max-height: 100%;
        width: 67%;
        height: 100%;
        margin-top: 0.5rem;
      }
    }
    .contact-part2 {
      text-align: left;
      background-color: #5ea2ec;
      height: 4rem;
      margin-top: -1.2rem;
      margin-bottom: -1rem;
      position: relative;
      @media screen and (max-width: 760px) {
        height: 3.5rem;
        margin-top: -3rem;
      }
      .info-detail {
        color: #fff;
        text-align: center;
        font-size: 0.3rem;
        position: absolute;
        bottom: .6rem;
        width: 7.76rem;
        left: 50%;
        margin-left: -3.88rem;
        #email {
          text-decoration: none;
          color: #fff;
        }
        @media screen and (max-width: 760px) {
          display: none;
        }
      }
    }
    .contact-detail {
      width: 100%;
      height: 7rem;
      background: url("../../assets/images/20180419/Crait_Contact.png") no-repeat center;
      /*background-size: contain;*/
      @media screen and (max-width: 760px) {
        height: 100%;
      }
      .contact-detail-dialog {
        width: 46%;
        height: 7.2rem;
        box-shadow: #888888 0 2px 20px;
        background-color: #fff;
        z-index: 99;
        display: inline-block;
        position: relative;
        margin-top: 0.85rem;
        padding: 0.7rem 0;
        @media screen and (min-width:1150px) and (max-width: 1440px) {
          width: 50%;
        }
        @media screen and (min-width: 875px) and (max-width: 1150px) {
          width: 60%;
        }
        @media screen and (min-width: 760px) and (max-width: 875px) {
          width: 70%;
        }
        @media screen and (max-width: 760px) {
          width: 100%;
          margin-top: .55rem;
          padding: .5rem 0;
          height: 100%;
        }
        .detail-part {
          display: flex;
          text-align: left;
          @media screen and (max-width: 760px) {
            display: block;
          }
          > div {
            flex: 1;
            padding: 0.2rem 0.4rem 0;
            .detail-title {
              font-size: 0.24rem;
              color: #666;
              @media screen and (max-width: 760px) {
                font-size: .18rem;
                color: #323232;
                font-weight: 500;
              }
            }
            .detail-content {
              margin-top: 0.18rem;
              @media screen and (max-width: 760px) {
                margin-top: 0;
              }
              input {
                width: 100%;
                height: 0.48rem;
                border: 1px solid #ddd;
                font-size: 0.3rem;
                padding: 0.1rem;
                @media screen and (max-width: 760px) {
                  height: .2rem;
                  border: none;
                  border-bottom: 1px solid #ddd;
                  outline: none;
                  font-size: .2rem;
                  padding: .15rem 0;
                }
              }
            }
          }
        }
        .contact-send {
          /*width: 90.9%;*/
          height: 0.6rem;
          background-color: #5ea2ec;
          margin: 0.58rem 0.4rem 0;
          border-radius: 0.04rem;
          text-align: center;
          line-height: 0.6rem;
          color: #fff;
          font-size: 0.3rem;
          cursor: pointer;
          @media screen and (max-width: 760px) {
            height: 0.4rem;
            line-height: 0.4rem;
            font-size: .2rem;
            margin: 0.58rem 0.2rem 0;
          }
        }
      }
    }
  }
  .el-message .el-icon-warning, .el-message .el-icon-success, .el-message .el-icon-error {
    font-size: .2rem;
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?695f7973